import { useState } from 'react'

import { SectionState } from 'states/PromoPageState/state'
import { AdminHeaderBlockElem } from 'components/AdminV2/UI/HeaderBlockElem/AdminHeaderBlockElem'
import { AdminInput } from 'components/AdminV2/UI/Input/AdminInput'
import { AdminTextArea } from 'components/AdminV2/UI/TextArea/AdminTextArea'
import { Href } from 'components/ui/Href/Href'
import { uploadFile } from 'utils/helpers/files/fileUpload'
import { getAltFromSrc } from 'utils/helpers/getAltFromSrc/getAltFromSrc'
import { ContractorData, ContractorDataItemType, VideoMonitoringContractorDataItem } from 'types/types'

import s from './ContractorBlockItem.module.scss'

type ContractorItemProps = {
  dataType: 'videoConnectionData' | 'signboardData' | 'outsourcingData'
  index: number
  localPromoState: SectionState
  setLocalPromoState: React.Dispatch<React.SetStateAction<SectionState>>
  selectedCountry?: string
  setSelectedCountry?: React.Dispatch<React.SetStateAction<string>>
}

export const ContractorBlockItem = ({
  index,
  dataType,
  localPromoState,
  setLocalPromoState,
  selectedCountry,
}: ContractorItemProps) => {
  const [state, setState] = useState<SectionState>(localPromoState)

  const data = state.content as ContractorData

  let title = ''
  let websiteLink = ''
  let instructionsLink = ''
  let additionalLink = ''
  let img = ''
  let phone = ''
  let email = ''
  let description = ''
  let link = ''

  if (dataType === 'videoConnectionData') {
    const countryData = data.videoConnectionData.find((country) => country.country === selectedCountry)
    if (countryData) {
      const contractor = countryData.contractors[index]
      if (contractor) {
        title = contractor.title
        websiteLink = contractor.websiteLink
        instructionsLink = contractor.instructionsLink
      }
    }
  } else {
    const contractor = data[dataType][index]
    if (contractor) {
      title = contractor.title
      link = contractor.link || ''
      additionalLink = contractor.additionalLink || ''
      img = contractor.img || ''
      phone = contractor.phone || ''
      email = contractor.email || ''
      description = contractor.description || ''
    }
  }

  const deleteContractorHandler = () => {
    const stateCopy = { ...state }
    const data = stateCopy.content as ContractorData

    if (dataType === 'videoConnectionData') {
      const countryData = data.videoConnectionData.find((country) => country.country === selectedCountry)
      if (countryData) {
        countryData.contractors = countryData.contractors.filter((contractor) => contractor.title !== title)
        countryData.contractors.forEach((contractor, index) => {
          contractor.index = index
        })
      }
    } else {
      let contractorData = data[dataType]
      contractorData = contractorData.filter((contractor) => contractor.title !== title)
      contractorData.forEach((contractor, index) => {
        contractor.index = index
      })
      data[dataType] = contractorData
    }

    stateCopy.content = data
    setLocalPromoState(stateCopy)
  }

  const changeInputHandler = (
    value: string,
    key: keyof ContractorDataItemType | keyof VideoMonitoringContractorDataItem,
  ) => {
    const stateCopy = { ...state }
    const data = stateCopy.content as ContractorData

    if (dataType === 'videoConnectionData') {
      const countryData = data.videoConnectionData.find((country) => country.country === selectedCountry)
      if (countryData) {
        const contractor = countryData.contractors[index]
        if (contractor && key in contractor) {
          ;(contractor as Record<string, any>)[key] = value
        }
      }
    } else {
      const contractor = data[dataType][index]
      if (contractor && key in contractor) {
        ;(contractor as Record<string, any>)[key] = value
      }
    }

    setState(stateCopy)
  }

  const changeFileHandler = (file: File) => {
    const stateCopy = { ...state }
    const data = stateCopy.content as ContractorData

    uploadFile(file).then((imgUrl) => {
      if (imgUrl && dataType !== 'videoConnectionData') {
        const contractor = data[dataType][index]
        if (contractor) {
          contractor.img = imgUrl
        }

        setLocalPromoState(stateCopy)
      }
    })
  }

  return (
    <div className={s.wrap}>
      <AdminHeaderBlockElem index={index} text={'Подрядчик'} onClick={deleteContractorHandler} />

      {dataType !== 'videoConnectionData' ? (
        <>
          <AdminInput
            label="Заголовок"
            value={title}
            onChange={(value: string) => changeInputHandler(value, 'title')}
            labelSize="16px"
          />
          <AdminTextArea
            label="Описание"
            value={description}
            onChange={(value: string) => changeInputHandler(value, 'description')}
            labelSize="16px"
          />

          <div className={s.imgFileWrap}>
            <div className={s.imgWrap}>
              <img className={s.img} src={img} alt={img && getAltFromSrc(img)} />
              <div className={s.urlToImgWrap}>
                <Href href={img} target="_blank" linkType="search">
                  {img}
                </Href>
              </div>
            </div>

            <AdminInput label="Лого" type="file" onChange={changeFileHandler} />
          </div>

          <AdminInput
            label="Телефон"
            value={phone}
            onChange={(value: string) => changeInputHandler(value, 'phone')}
            labelSize="16px"
          />

          <AdminInput
            label="Почта"
            value={email}
            onChange={(value: string) => changeInputHandler(value, 'email')}
            labelSize="16px"
          />

          <AdminInput
            label="Ссылка на сайт"
            value={link}
            onChange={(value: string) => changeInputHandler(value, 'link')}
            labelSize="16px"
          />

          <AdminInput
            label="Доп ссылка"
            value={additionalLink}
            onChange={(value: string) => changeInputHandler(value, 'additionalLink')}
            labelSize="16px"
          />
        </>
      ) : (
        <>
          <AdminInput
            label="Заголовок"
            value={title}
            onChange={(value: string) => changeInputHandler(value, 'title')}
            labelSize="16px"
          />

          <AdminInput
            label="Ссылка на сайт"
            value={websiteLink}
            onChange={(value: string) => changeInputHandler(value, 'websiteLink')}
            labelSize="16px"
          />

          <AdminInput
            label="Инструкция"
            value={instructionsLink}
            onChange={(value: string) => changeInputHandler(value, 'instructionsLink')}
            labelSize="16px"
          />
        </>
      )}
    </div>
  )
}
